<mat-form-field>
  <mat-select class="mat-form-field mat-form-field-fluid" [formControl]="control" multiple>
    <mat-select-trigger>
      {{ firstSelectedName || "" }}
      <span *ngIf="control.value?.length > 1">
        (+{{ control.value.length - 1 }} {{ control.value.length === 2 ? "other" : "others" }})
      </span>
    </mat-select-trigger>

    <mat-optgroup>
      <mat-form-field style="width: 100%">
        <input
          #search
          placeholder="search"
          autocomplete="off"
          aria-label="Search"
          matInput
          [formControl]="searchTextboxControl"
        />
      </mat-form-field>
    </mat-optgroup>

    <mat-optgroup *ngIf="(filteredOptions | async)?.length === 0">
      <div>No results found!</div>
    </mat-optgroup>

    <mat-option
      *ngFor="let option of filteredOptions | async"
      [value]="option.id"
      (onSelectionChange)="selectionChange($event, option)"
    >
      {{ option.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
